export default __webpack_public_path__ + "static/media/bandh.b8c80dd7.png";